import { getEnv } from "../../../../../AppConfigs";
import { DateFormat, EmailType } from "../../../../../constants";
import { approvedFields } from "../../../../../constants/approveFields";
import { mailRegexs } from "../../../../../constants/mailTemplateConstants";
import { DateHelper, StringHelper } from "../../../../../helper";
import { useMail } from "../../../../../hook";
import { MailService } from "../../../../../services/mail/mail.service";
import { useSelector } from "../../../../../store/store";

const siteUrl = getEnv("REACT_APP_DOMAIN_URL");

interface ISendMailRejected {
  mailTo: { name: string; email: string };
  eMailType: EmailType;
  requestName: string;
  deletor: { name: string; email: string };
  deleteMessage: string;
}

export const useSendMail = () => {
  const mailTemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const { sendMail, sendMailChangeApproval } = useMail();

  const getApprovalFieldName = (record: any): string => {
    for (const e of approvedFields) {
      if (!record[e.field]) continue;
      if (!record[e.status]) return e.field;
    }

    return "";
  };

  const sendMailUpdateApproval = (
    record: any,
    row: any,
    { approval, change }: { approval: EmailType; change: EmailType },
    routes: string,
  ) => {
    const fieldSendMail = getApprovalFieldName(record);
    if (fieldSendMail && record[fieldSendMail] !== row[fieldSendMail]) {
      const commandFields = {
        toPath: siteUrl + routes,
        created: {
          byName: record.createdName,
          dateTime: DateHelper.formatDateToString(record.createdDate, { format: DateFormat.DD_MM_YYYY_HH_MM }),
        },
        id: record.id,
        description: record.eDescription
      };

      const fieldChangeApproval = {
        ...commandFields,
        mailTo: {
          email: StringHelper.verticalBarSplit<string[]>(record[fieldSendMail])[0],
          name: StringHelper.verticalBarSplit<string[]>(record[fieldSendMail])[1],
        },
        eMailType: change,
        approval: {
          name: StringHelper.verticalBarSplit<string[]>(row[fieldSendMail])[1],
          email: StringHelper.verticalBarSplit<string[]>(row[fieldSendMail])[0],
        },
        id: record.id,
        description: record.eDescription
      };
      sendMailChangeApproval(fieldChangeApproval);

      const fieldToNewApproval = {
        ...commandFields,
        eMailType: approval,
        mailTo: {
          email: StringHelper.verticalBarSplit<string[]>(row[fieldSendMail])[0],
          name: StringHelper.verticalBarSplit<string[]>(row[fieldSendMail])[1],
        },
        id: record.id,
        description: record.eDescription
      };
      sendMail(fieldToNewApproval);
    }
  };

  const sendMailDeleteRequest = async ({
    mailTo,
    requestName,
    eMailType,
    deletor,
    deleteMessage,
  }: ISendMailRejected) => {
    const template = mailTemplates.find((m: any) => m.eMailType === eMailType);
    const content = template.eContent
      .replace(mailRegexs.zero + ";", mailTo.name)
      .replace(mailRegexs.one + ";", requestName)
      .replace(mailRegexs.two + ";", `${deletor.name} (${deletor.email})`)
      .replace(mailRegexs.three + ";", deleteMessage || "");
    const message = MailService.buildMailMesssage(template.eSubject, content, "html", mailTo.email);
    await MailService.sendMail(message);
  };

  return { sendMailUpdateApproval, sendMailDeleteRequest };
};
